// File: src/components/pages/ManageBookings.jsx
// ServiceProvider (Instructor) page - Manage booking-related tasks
// UPDATED: Added "Cancel For Students" tab after "Book For Students"

import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import InstructorBookingSlots from './InstructorBookingSlots';
import Cancellations from './Cancellations';
import BookForStudents from './BookForStudents';
import CancelForStudents from './CancelForStudents';
import { AUTH0_NAMESPACE } from '../../utils/constants';
import '../../styles/modules.css';

export default function ManageBookings() {
  const { user } = useAuth0();
  const userRoles = user?.[`${AUTH0_NAMESPACE}/roles`] || [];
  
  const isServiceProvider = userRoles.includes('ServiceProvider');

  // Default to 'booking-slots' tab
  const [activeTab, setActiveTab] = useState('booking-slots');

  // Access control - only ServiceProvider can access this page
  if (!isServiceProvider) {
    return (
      <div className="access-denied-container">
        <h2>Access Denied</h2>
        <p>This page is only accessible to instructors.</p>
        <p>Please contact your administrator if you believe this is an error.</p>
      </div>
    );
  }

  return (
    <div className="manage-bookings-page">
      {/* Tab Navigation */}
      <div className="tabs">
        <button
          className={`tab ${activeTab === 'booking-slots' ? 'tab-active' : ''}`}
          onClick={() => setActiveTab('booking-slots')}
        >
          Booking Slots
        </button>
        <button
          className={`tab ${activeTab === 'cancellations' ? 'tab-active' : ''}`}
          onClick={() => setActiveTab('cancellations')}
        >
          Cancellations
        </button>
        
        <button
          className={`tab ${activeTab === 'book-for-students' ? 'tab-active' : ''}`}
          onClick={() => setActiveTab('book-for-students')}
        >
          Book For Students
        </button>

        <button
          className={`tab ${activeTab === 'cancel-for-students' ? 'tab-active' : ''}`}
          onClick={() => setActiveTab('cancel-for-students')}
        >
          Cancel For Students
        </button>
        
        {/* Future tabs can be added here:
        <button
          className={`tab ${activeTab === 'analytics' ? 'tab-active' : ''}`}
          onClick={() => setActiveTab('analytics')}
        >
          Analytics
        </button>
        */}
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === 'booking-slots' && <InstructorBookingSlots />}
        {activeTab === 'cancellations' && <Cancellations />}
        {activeTab === 'book-for-students' && <BookForStudents />}
        {activeTab === 'cancel-for-students' && <CancelForStudents />}
        {/* Future tab content can be added here */}
      </div>
    </div>
  );
}